import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkspaces = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1206_7619",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1206_7619)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.2359 10.2885L11.9874 9.23083L13.739 10.2885L13.2711 8.29L14.8176 6.95667L12.7903 6.78521L11.9874 4.90396L11.1847 6.78521L9.15737 6.95667L10.7038 8.29L10.2359 10.2885ZM12.3145 15.609H15.2663C15.2172 15.8899 15.0999 16.1215 14.9147 16.3038C14.7292 16.4858 14.4917 16.5993 14.2022 16.6442L4.9507 17.7883C4.53501 17.8472 4.16189 17.749 3.83133 17.4935C3.50064 17.2383 3.31015 16.9028 3.25987 16.4871L2.19591 7.88792C2.14564 7.47222 2.24737 7.09854 2.50112 6.76688C2.75487 6.43507 3.08952 6.24674 3.50508 6.20188L4.39133 6.10896V7.35896L3.67341 7.43917C3.59855 7.44445 3.5398 7.47514 3.49716 7.53125C3.45439 7.58736 3.43834 7.65278 3.44904 7.7275L4.50987 16.3269C4.52057 16.4017 4.55265 16.4605 4.60612 16.5031C4.65945 16.5459 4.72355 16.5619 4.79841 16.5513L12.3145 15.609ZM7.56445 13.9423C7.14348 13.9423 6.78716 13.7965 6.4955 13.5048C6.20383 13.2131 6.058 12.8568 6.058 12.4358V3.58979C6.058 3.16882 6.20383 2.8125 6.4955 2.52083C6.78716 2.22917 7.14348 2.08333 7.56445 2.08333H16.4105C16.8315 2.08333 17.1878 2.22917 17.4795 2.52083C17.7711 2.8125 17.917 3.16882 17.917 3.58979V12.4358C17.917 12.8568 17.7711 13.2131 17.4795 13.5048C17.1878 13.7965 16.8315 13.9423 16.4105 13.9423H7.56445ZM7.56445 12.6923H16.4105C16.4854 12.6923 16.5468 12.6683 16.5949 12.6202C16.6429 12.5722 16.667 12.5107 16.667 12.4358V3.58979C16.667 3.51493 16.6429 3.45347 16.5949 3.40542C16.5468 3.35736 16.4854 3.33333 16.4105 3.33333H7.56445C7.48959 3.33333 7.42814 3.35736 7.38008 3.40542C7.33202 3.45347 7.308 3.51493 7.308 3.58979V12.4358C7.308 12.5107 7.33202 12.5722 7.38008 12.6202C7.42814 12.6683 7.48959 12.6923 7.56445 12.6923Z",
			fill: "currentColor"
		})
	})]
});
export default SvgWorkspaces;
